import React from "react";
import "./WordInfoModal.css";

const TranslationSection = ({ data }) => {
  if (!data?.dict || data.dict.length === 0) {
    return (
      <div className="translation-section empty">
        <p>ترجمه‌ای یافت نشد</p>
      </div>
    );
  }

  const displayData = data.dict.map((item) => ({
    pos: item.pos || "nopos",
    translations: item.translations || [],
  }));

  return (
    <div className="translation-section">
      <div className="translation-grouped">
        {displayData.map((item, itemIndex) => (
          <div key={itemIndex} className="translation-line">
            <span className="pos-label">{item.pos}</span>
            <span className="pos-separator"> : </span>
            <span className="translations-text">
              {item.translations.join("، ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranslationSection;
